module.exports = __webpack_public_path__ + "img/moto.9e3bb098.svg";